import { EventHandler } from "../../../util/event/EventHandler";
import { AppCore } from "../AppCore";
import { RequestConstants } from "./RequestConstants";
/**
 * HttpRequest.ts
 */
export class HttpRequest {
    constructor(method, url) {
        this.method = method;
        this.url = url;
        this.setDefaults();
        this.core = AppCore.getInstance();
    }
    setDefaults() {
        this.async = true;
        this.contentType = RequestConstants.APPLICATION_JSON;
        this.responseType = RequestConstants.TEXT;
        this.progress = 0;
    }
    send(data) {
        this.data = data;
        this.request = new XMLHttpRequest();
        this.request.onprogress = this.handleLoadProgress.bind(this);
        this.request.onload = this.handleLoadSuccess.bind(this);
        this.request.onerror = this.handleError.bind(this);
        this.method == RequestConstants.GET ? this.sendGET() : this.sendPOST(this.data);
    }
    sendGET() {
        this.request.open(this.method, this.url, this.async);
        if (this.token != null) {
            this.request.setRequestHeader("Authorization", this.token);
        }
        this.request.responseType = this.responseType;
        this.request.send();
    }
    sendPOST(data) {
        this.request.open(this.method, this.url, this.async);
        this.request.setRequestHeader("Accept", this.contentType);
        this.request.setRequestHeader("Content-type", this.contentType);
        if (this.token != null) {
            this.request.setRequestHeader("Authorization", this.token);
        }
        if (this.async) {
            this.request.responseType = this.responseType;
        }
        this.request.send(data);
    }
    sendPUT(data) {
        this.request.open(this.method, this.url, this.async);
        this.request.setRequestHeader("Accept", this.contentType);
        this.request.setRequestHeader("Content-type", this.contentType);
        if (this.token != null) {
            this.request.setRequestHeader("Authorization", this.token);
        }
        if (this.async) {
            this.request.responseType = this.responseType;
        }
        this.request.send(data);
    }
    handleLoadProgress(event) {
        if (event.lengthComputable) {
            this.progress = (event.loaded / event.total) * 100;
            if (this.progressHandler) {
                this.progressHandler.call();
            }
        }
    }
    handleLoadSuccess(event) {
        if (this.request.status == 200 || this.request.status == 0) {
            this.completeHandler.call();
        }
        else {
            this.handleLoadFailed();
        }
    }
    handleLoadFailed(event) {
        this.errorHandler.call();
    }
    handleError(event) {
        this.handleLoadFailed(event);
    }
    setAsync(value) {
        this.async = value;
    }
    setToken(value) {
        this.token = value;
    }
    setContentType(value) {
        this.contentType = value;
    }
    setResponseType(value) {
        this.responseType = value;
    }
    getRequest() {
        return this.request;
    }
    getProgress() {
        return this.progress;
    }
    getResponse() {
        return this.request.response;
    }
    getJSON() {
        if (this.request.responseText) {
            return JSON.parse(this.request.responseText);
        }
        return {};
    }
    getXML() {
        return this.request.responseXML;
    }
    onProgress(handler, scope) {
        this.progressHandler = new EventHandler(handler, scope);
    }
    onComplete(handler, scope) {
        this.completeHandler = new EventHandler(handler, scope);
    }
    onError(handler, scope) {
        this.errorHandler = new EventHandler(handler, scope);
    }
}
//# sourceMappingURL=HttpRequest.js.map